webpackJsonp([70144966829960],{

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contact-header-big.a18782f7.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contact-header-small.0ea8e1ab.jpg";

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormStyle = /*#__PURE__*/(0, _reactEmotion.css)("margin:0 0 1em 0;width:100%;");
	
	var MessageStyle = /*#__PURE__*/(0, _reactEmotion.css)("width:100%;margin:0 0 1em 0;line-height:1.6;min-height:250px;resize:vertical;");
	
	var basicButton = /*#__PURE__*/(0, _reactEmotion.css)("width:100%;text-align:center;padding:1rem 3rem;font-weight:600;transition:all 0.3s ease 0s;border:2px solid ", _colors2.default.black, ";");
	
	var primaryButton = /*#__PURE__*/(0, _reactEmotion.css)(basicButton, "\n  color:white;background-color:", _colors2.default.black, ";&:hover{cursor:pointer;color:", _colors2.default.black, ";background-color:white;}");
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	}
	
	var ContactForm = function (_Component) {
	  _inherits(ContactForm, _Component);
	
	  function ContactForm(props) {
	    _classCallCheck(this, ContactForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      fetch("/", {
	        method: "POST",
	        headers: {
	          "Content-Type": "application/x-www-form-urlencoded"
	        },
	        body: encode(_extends({
	          "form-name": "contact"
	        }, _this.state))
	      }).then(function () {
	        return (0, _gatsbyLink.navigateTo)('/thanks');
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      e.preventDefault();
	    };
	
	    _this.state = {};
	
	    return _this;
	  }
	
	  ContactForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "form",
	        {
	          name: "contact",
	          method: "post",
	          action: "/thanks/",
	          "data-netlify": "true",
	          "data-netlify-honeypot": "bot-field",
	          onSubmit: this.handleSubmit
	        },
	        _react2.default.createElement(
	          "p",
	          { hidden: true },
	          _react2.default.createElement(
	            "label",
	            null,
	            "Don\u2019t fill this out:",
	            _react2.default.createElement("input", { name: "bot-field", onChange: this.handleChange })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "name" },
	            "Name"
	          ),
	          _react2.default.createElement("input", { className: FormStyle, type: "text", name: "name", onChange: this.handleChange, required: true })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "email" },
	            "Email"
	          ),
	          _react2.default.createElement("input", { type: "text", className: FormStyle, name: "email", onChange: this.handleChange, required: true })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "message" },
	            "Message"
	          ),
	          _react2.default.createElement("textarea", { name: "message", onChange: this.handleChange, className: MessageStyle, rows: "6", required: true })
	        ),
	        _react2.default.createElement(
	          "button",
	          { type: "submit", className: primaryButton },
	          "Send Message"
	        )
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react.Component);
	
	exports.default = ContactForm;
	module.exports = exports["default"];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _contactHeaderBig = __webpack_require__(435);
	
	var _contactHeaderBig2 = _interopRequireDefault(_contactHeaderBig);
	
	var _contactHeaderSmall = __webpack_require__(436);
	
	var _contactHeaderSmall2 = _interopRequireDefault(_contactHeaderSmall);
	
	var _Layout = __webpack_require__(7);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ContactForm = __webpack_require__(168);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormStyle = /*#__PURE__*/(0, _reactEmotion.css)("margin:0 0 1em 0;width:100%;");
	
	var MessageStyle = /*#__PURE__*/(0, _reactEmotion.css)("width:100%;margin:0 0 1em 0;line-height:1.6;min-height:250px;resize:vertical;");
	
	var basicButton = /*#__PURE__*/(0, _reactEmotion.css)("width:100%;text-align:center;padding:1rem 3rem;font-weight:600;transition:all 0.3s ease 0s;border:2px solid ", _colors2.default.black, ";");
	
	var primaryButton = /*#__PURE__*/(0, _reactEmotion.css)(basicButton, "\n  color:white;background-color:", _colors2.default.black, ";&:hover{cursor:pointer;color:", _colors2.default.black, ";background-color:white;}");
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var social_links = data.allBusinessJson.edges[0].node.social_links;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Hero2.default,
	      { imageBig: _contactHeaderBig2.default, imageSmall: _contactHeaderSmall2.default },
	      _react2.default.createElement(
	        _Layout.Box,
	        { color: "white", p: [3, 3, 4], align: "left" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Contact"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      { color: _colors2.default.black, p: [3, 3, 4], align: "left" },
	      _react2.default.createElement(
	        _Layout.ContentWrapper,
	        null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Need help with Your Data? Get in touch"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          " PCS never shares your data."
	        ),
	        _react2.default.createElement(_ContactForm2.default, null),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If you wanna get in touch, to see how PCS can help with your next project and save you money fill out the form below."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Or send us an e-mail to:"
	        ),
	        _react2.default.createElement(
	          "h4",
	          null,
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:" + social_links.email },
	            social_links.email
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "and call us anytime 877-307-8131"
	        ),
	        _react2.default.createElement("br", null)
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-811149a0c8407d74b751.js